import React from 'react';

import { Button, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { TablePagination as MuiTablePagination } from '@material-ui/core';

import { ArrowLeft } from 'assets/assetsV1/iconComponents/ArrowLeft';
import { ArrowRight } from 'assets/assetsV1/iconComponents/ArrowRight';

const StyledTablePagination = styled(MuiTablePagination)`
  border: none;
  & .MuiTablePagination-caption {
    font-size: 12px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.text.g2};
  }
`;

const PaginationActionButton = styled(Button)`
  box-shadow: none !important;
  min-width: auto;
  background-color: ${(props) => props.theme.colors.neutral.F5F7F9};
  border: 1px solid ${(props) => props.theme.colors.neutral.CFD7DF};
  height: 18px;
  width: 18px;
  padding: 0;
  margin: 0;
  &:hover {
    background-color: ${(props) => props.theme.colors.neutral.F5F7F9};
  }
  &:active {
    background-color: ${(props) => props.theme.colors.neutral.F5F7F9};
  }
  & .chakra-button__icon {
    margin: 0;
  }
`;

const PaginationActionsComponents = ({ disableNextButton, count, page, rowsPerPage, onPageChange = () => {} }) => {
  const nextButtonDisabled = count > -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : disableNextButton;
  const previousButtonDisabled = page === 0;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  return (
    <Flex sx={{ marginLeft: '8px', marginRight: '12px' }}>
      <PaginationActionButton
        variant="outline"
        size="sm"
        leftIcon={<ArrowLeft boxSize="16px" />}
        isDisabled={previousButtonDisabled}
        style={{ borderRadius: '2px 0px 0px 2px' }}
        onClick={handleBackButtonClick}
      />
      <PaginationActionButton
        variant="outline"
        size="sm"
        leftIcon={<ArrowRight boxSize="16px" />}
        isDisabled={nextButtonDisabled}
        style={{ borderRadius: '0px 2px 2px 0px' }}
        onClick={handleNextButtonClick}
      />
    </Flex>
  );
};

const TablePagination = ({
  count,
  page,
  onPageChange,
  rowsPerPage,
  handleChangeRowsPerPage,
  rowsPerPageOptions = [],
  labelDisplayedRows = null,
  // following will only be used if count is less than 0.
  disableNextButton = false,
}) => (
  <StyledTablePagination
    count={count}
    page={page}
    onPageChange={onPageChange}
    rowsPerPage={rowsPerPage}
    onChangeRowsPerPage={handleChangeRowsPerPage}
    rowsPerPageOptions={rowsPerPageOptions}
    nextIconButtonProps={{
      disableRipple: true,
      disableFocusRipple: true,
      size: 'small',
    }}
    ActionsComponent={(props) => <PaginationActionsComponents {...props} disableNextButton={disableNextButton} />}
    {...(typeof labelDisplayedRows === 'function' && { labelDisplayedRows })}
  />
);

export { TablePagination };
